import React from 'react';
import { Box, useTheme, styled, useMediaQuery, IconButton, Tooltip } from '@mui/material';
import LocalizationDropdown from '../Localization/Components/LocalizationDropdown';
import TimezoneDropdown from '../Timezone/Components/TimezoneDropdown';
import GlobalSearch from './GlobalSearch';
import { PERMISSIONS } from '../Auth/Constants/constants';
import { useSelector } from 'react-redux';
import { ManageAccounts } from '@mui/icons-material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { paths } from '../routes/constants';

const AppHeaderContainer = styled(Box)(({ theme, isSmDown }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  padding: '8px 24px 8px 24px',
  display: isSmDown ? 'block' : 'flex',
  justifyContent: isSmDown ? 'flex-start' : 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('sm')]: {
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    boxShadow: '0px 2px 4px rgba(185, 185, 185, 0.1)',
  },
}));

const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '7px',
  // flexWrap: 'wrap',
});

const AppHeader = ({ customStyles = {}, ...rest }) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const history = useHistory();
  const permissions = useSelector((state) => state.auth.user?.permissions);
  const isLocalizationEnabled = permissions?.includes(PERMISSIONS.ENABLE_LOCALIZATION);
  const isGlobalSearchEnabled = permissions?.includes(PERMISSIONS.OMS_GLOBAL_SEARCH);
  return (
    <>
      <AppHeaderContainer
        isSmDown={isSmDown}
        sx={{
          color: theme.palette.text.primary,
          ...customStyles,
        }}
        data-testid="top-header"
        {...rest}
      >
        <LeftSection></LeftSection>
        <RightSection>
          {isGlobalSearchEnabled && <GlobalSearch />}
          {isLocalizationEnabled && <LocalizationDropdown />}
          <TimezoneDropdown />
          <IconButton onClick={() => history.push(paths.ACCOUNT_SETTINGS)} data-testid="account-settings">
            <Tooltip title="Account Settings">
              <ManageAccounts sx={{ color: (theme) => theme.palette.primary.light }} />
            </Tooltip>
          </IconButton>
        </RightSection>
      </AppHeaderContainer>
    </>
  );
};

export default AppHeader;
